// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import ImageField from "../../components/ImageField";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class ApplicationCustomization extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleFileChange(event) {
    this.props.updateField({ [event.target.name]: event.target.files[0] });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;

    const introVideo =
      files.introVideoFile !== undefined ? (
        <React.Fragment>
          <video width="320" height="240" controls>
            <source src={files.introVideoFile} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <input
            type="checkbox"
            name="delete_introVideo"
            onClick={this.handleCheckboxChange}
          />{" "}
          Delete
        </React.Fragment>
      ) : null;
    const outroVideo =
      files.outroVideoFile !== undefined ? (
        <React.Fragment>
          <video width="320" height="240" controls>
            <source src={files.outroVideoFile} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <input
            type="checkbox"
            name="delete_outroVideo"
            onClick={this.handleCheckboxChange}
          />{" "}
          Delete
        </React.Fragment>
      ) : null;

    const cover =
      config.cover === "2" ? (
        <React.Fragment>
          <FormGroup row>
            <Label for="introVideo" sm={2}>
              Intro video
            </Label>
            <Col>
              <Input
                type="file"
                accept="video/mp4"
                name="introVideo"
                id="introVideo"
                onChange={this.handleFileChange}
              />
            </Col>

            <Col>{introVideo}</Col>
          </FormGroup>
          <FormGroup row>
            <Label for="outroVideo" sm={2}>
              Outro video
            </Label>
            <Col>
              <Input
                type="file"
                accept="video/mp4"
                name="outroVideo"
                id="outroVideo"
                onChange={this.handleFileChange}
              />
            </Col>
            <Col>{outroVideo}</Col>
          </FormGroup>
        </React.Fragment>
      ) : config.cover === "1" ? (
        <FormGroup row>
          <ImageField
            id="coverImage"
            label="Cover image"
            image={files.coverImageFile}
            onDeleteChange={this.handleCheckboxChange}
            onFileChange={this.handleValidatedFileChange}
          />
        </FormGroup>
      ) : null;

    const theme =
      config.theme === "CUSTOM" ? (
        <React.Fragment>
          <FormGroup row>
            <Label for="pathToBGImage" sm={2}>
              Image 1
            </Label>
            <Col>
              <Input
                type="file"
                name="pathToBGImage"
                id="pathToBGImage"
                onChange={this.handleFileChange}
                accept="image/png"
                required={config.theme === "CUSTOM" && !files.pathToBGImageFile}
              />
            </Col>
            <Col>
              <img src={files.pathToBGImageFile} alt="" className="col-md-9" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="pathToBGImage2" sm={2}>
              Image 2
            </Label>
            <Col>
              <Input
                type="file"
                name="pathToBGImage2"
                id="pathToBGImage2"
                onChange={this.handleFileChange}
                accept="image/png"
                required={
                  config.theme === "CUSTOM" && !files.pathToBGImage2File
                }
              />
            </Col>
            <Col>
              <img src={files.pathToBGImage2File} alt="" className="col-md-9" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="pathToBGImage3" sm={2}>
              Image 3
            </Label>
            <Col>
              <Input
                type="file"
                name="pathToBGImage3"
                id="pathToBGImage3"
                onChange={this.handleFileChange}
                accept="image/png"
                required={
                  config.theme === "CUSTOM" && !files.pathToBGImage3File
                }
              />
            </Col>
            <Col>
              <img src={files.pathToBGImage3File} alt="" className="col-md-9" />
            </Col>
          </FormGroup>
        </React.Fragment>
      ) : null;

    return (
      <Section title="Application customization" closed>
        <FormGroup row>
          <Label for="cover" sm={2}>
            Cover type
          </Label>
          <Col>
            <Input
              value={config.cover}
              sm={2}
              type="select"
              name="cover"
              id="cover"
              className="dropdown-black"
              onChange={this.handleChange}
            >
              <option value="">None</option>
              <option value="1">Image</option>
              <option value="2">Video</option>
            </Input>
          </Col>
        </FormGroup>
        {cover}

        <FormGroup row>
          <Label for="theme" sm={2}>
            Theme
          </Label>
          <Col>
            <Input
              value={config.theme}
              sm={2}
              type="select"
              name="theme"
              id="theme"
              className="dropdown-black"
              onChange={this.handleChange}
              required
            >
              <option value="" selected={!config.cover} disabled>
                -- Select theme --
              </option>
              <option value="DARK">Dark</option>
              <option value="LIGHT">Light</option>
              <option value="CUSTOM">Custom</option>
            </Input>
          </Col>
        </FormGroup>
        {theme}

      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationCustomization);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/ApplicationCustomization.jsx